import { A03 } from 'api/U013';
import { useState } from 'react';

type UseDeleteLineAccountLinkType = {
  isLoading: boolean;
  deleteLineAccountLink: (userId: string, revision: number) => Promise<void>;
};

export function useDeleteLineAccountLink(): UseDeleteLineAccountLinkType {
  // state
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // function
  const deleteLineAccountLink = async (userId: string, revision: number) => {
    try {
      setIsLoading(true);
      await A03(userId, revision);
      setIsLoading(false);
    } catch (err: unknown) {
      setIsLoading(false);
      console.error(err);
      throw new Error();
    }
  };

  return { isLoading, deleteLineAccountLink };
}
